<template lang="pug">
b-modal#bankTransfer(
  ref="bankTransfer"
  :title="$t('ui.bank_transfer')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
  )
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.bank_from')").mb-1
      BankAccountList(
        ref="bank_from"
        size="sm"
        required
        type="array"
        :dirty="$v.bank_from.$dirty"
        :error="$v.bank_from.$error"
        v-model.trim.lazy="$v.bank_from.$model"
        :excludeOpt="$v.bank_to.$model"
        :disabled="loading"
        filterBalance=true
        filterBankAccStatus=true
        :optionList="options"
      )
      ValidateResult(:value="$v.bank_from" :name="$t('ui.bank_from')")
    b-form-group(:label="$t('ui.bank_to')").mb-1
      BankAccountList(
        ref="bank_to"
        size="sm"
        required
        type="array"
        :dirty="$v.bank_to.$dirty"
        :error="$v.bank_to.$error"
        v-model.trim.lazy="$v.bank_to.$model"
        :excludeOpt="$v.bank_from.$model"
        :disabled="loading"
        filterBankAccStatus=true
        :optionList="options"
      )
      ValidateResult(:value="$v.bank_to" :name="$t('ui.bank_to')")
    b-form-group(:label="$t('ui.amount')").mb-1
      DebounceInput(
        size="sm"
        ref="amount"
        required
        type="text"
        :dirty="$v.amount.$dirty"
        :error="$v.amount.$error"
        v-model.trim.lazy="$v.amount.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.amount" :name="$t('ui.amount')")
    b-form-group(:label="$t('ui.remark')").mb-1
      b-form-textarea(v-model="remark" style="height:80px;")
    .row
      .col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.close')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>
<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, maxValue } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import BankAccountList from "@/library/BankAccountList";
import DebounceInput from "@/library/DebounceInput";
const greaterThanZero = value => value > 0;
import xhr from "@/plugins/xhr.js";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ValidateResult,
    BankAccountList
  },
  props: {},
  data() {
    return {
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      bank_from: "",
      bank_to: "",
      amount: "",
      remark: "",
      options: []
    };
  },
  computed: {
    maxTransfer() {
      if (this.bank_from) return this.bank_from.split(" - ")[3];
      return 0;
    }
  },
  validations: {
    bank_from: {
      required
    },
    bank_to: {
      required
    },
    amount: {
      required,
      decimal,
      greaterThanZero,
      maxValue(value) {
        return maxValue(this.maxTransfer)(value);
      }
    }
  },
  mounted() {
    this.getBankAccList();
  },
  methods: {
    getBankAccList() {
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username,
        bank_acc_type: "BOTH",
        bank_status: 1
      };
      this.loading = true;
      xhr
        .doRequest(args, xhr.ACCOUNT.bankListForTransfer)
        .then(res => {
          this.loading = false;
          this.options = res.data.bank_list;
        })
        .catch(res => {
          this.loading = false;
          this.$helpers.handleFeedback(res.status);
        });
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var args = {
          session_token: this.$store.getters.sessionToken,
          action_by: this.$store.getters.username,
          amount: this.amount,
          sender_bank_id: this.bank_from.split(" - ")[0].trim(),
          sender_bank_acc_no: this.bank_from.split(" - ")[1].trim(),
          recipient_bank_id: this.bank_to.split(" - ")[0].trim(),
          recipient_bank_acc_no: this.bank_to.split(" - ")[1].trim(),
          remark: this.remark
        };

        console.log(args);

        this.feedback.success = true;
        this.loading = true;
        xhr
          .doRequest(args, xhr.ACCOUNT.bankTansfer)
          .then(res => {
            this.loading = false;
            this.feedback.success = res.success;
            this.feedback.status = res.status;

            if (this.feedback.success == true) {
              this.$emit("clicked");
              this.$refs.bankTransfer.hide();
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
              this.$emit("failed", "bank_transfer", this.feedback.status);
              this.$refs.bankTransfer.hide();
            }
          })
          .catch(res => {
            console.log(res);
            this.loading = false;
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          });
      }
    },
    reset() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown() {
      this.$v.$reset();
      this.bank_from = "";
      this.bank_to = "";
      this.amount = "";
      this.remark = "";
      this.$refs.bank_from.$el.focus();
    }
  }
};
</script>
<style lang="scss" scoped></style>
